<template>
  <div class="action-plan-electric-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p class="lead">{{ !printing ? 'Definir' : ''}} Detalhes do Serviço de Elétrica</p>
          <div v-if="!printing" class="d-flex">
            <router-link
              to="/action-plan/form"
              class="btn btn-success"
            >
              <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
              Voltar ao Plano de Ação
            </router-link>
            <div class="save-button ml-3">
              <button @click="save()" class="btn btn-primary">Definir</button>
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <div class="mt-4 w-50">
            <div class="col-12 col-md-12 break-after">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <custom-select-button
                      :title="'Trabalho a ser realizado em'"
                      :options="tensionOptions"
                      v-model="tensionOption"
                    />
                  </div>

                  <div class="form-group">
                    <custom-select-button
                      :title="'Intertravamento com projeto(s) de máquina(s)?'"
                      :options="machineProjetcsInterlockOptions"
                      v-model="machineProjetcsInterlockOption"
                    />
                  </div>
                  <div class="form-group">
                    <label>Citar tipo/modelo/marca</label>
                    <input
                      v-model="machineProjetcsInterlockResponse"
                      type="text"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group break-after">
                    <label
                      >Descreva os dispositivos / materiais a serem instalados</label
                    >
                    <textarea
                      v-model="devicesDescription"
                      type="text"
                      class="form-control"
                      rows="10"
                      style="height: 338px"
                    ></textarea>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-group">
                    <label>Descreva os materiais de apoio necessários</label>
                    <textarea
                      v-model="materialsDescription"
                      type="text"
                      class="form-control"
                      rows="10"
                      style="height: auto"
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label>Descreva os EPI's e equipamentos necessários</label>
                    <textarea
                      v-model="episDescription"
                      type="text"
                      class="form-control"
                      rows="10"
                      style="height: auto"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomSelectButton from '@/components/common/CustomSelectButton/CustomSelectButton.vue'
  import { useRoute } from 'vue-router'
  import useSwal from '../../../modules/Swal'

  const tensionOptions = [
    { label: 'Alta tensão', value: 1, color: '#f44336' },
    { label: 'Média tensão', value: 2, color: '#ff9800'},
    { label: 'Baixa tensão', value: 3,  color: '#4CAF50' },
  ]

  const machineProjetcsInterlockOptions = [
    { label: 'Não', value: 0, color: '#f44336' },
    { label: 'Sim', value: 1, color: '#4CAF50' },
  ]

  export default {
    setup(props) {
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId || props.riskAnalysisDescriptionId

      const { showSuccessDialog, showErrorDialog } = useSwal()

      return {
        tensionOptions,
        machineProjetcsInterlockOptions,
        showSuccessDialog,
        showErrorDialog,
        riskAnalysisDescriptionId,
      }
    },
    components: {
      CustomSelectButton,
    },
    props: {
      riskAnalysisDescriptionId: {
        type: Number,
        required: false,
      },
      printing: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data() {
      return {
        consultancy: false,

        tensionOption: '',
        machineProjetcsInterlockOption: '',
        machineProjetcsInterlockResponse: '',

        devicesDescription: '',
        materialsDescription: '',
        episDescription: '',

        loading: false,
      }
    },
    methods: {
      save() {
        let payload = {
          risk_analysis_description_id: this.riskAnalysisDescriptionId,
          eletric: {
            needs_consultancy: this.consultancy,
            voltage: this.tensionOption,
            interlock: this.machineProjetcsInterlockOption,
            interlock_details: this.machineProjetcsInterlockResponse,
            devices_and_materials: this.devicesDescription,
            support_materials: this.materialsDescription,
            epi: this.episDescription,
          },
        }
        this.axios
          .post(`/api/action-plan/services/eletric`, payload)
          .then(() => this.showSuccessDialog())
          .catch(() => this.showErrorDialog())
      },
      load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/services/${this.riskAnalysisDescriptionId}/electric`,
          )
          .then(({ data }) => {
            const service = data.electric_services[0]

            this.consultancy = data.needs_consultancy
            this.tensionOption = service.voltage
            this.machineProjetcsInterlockOption = service.interlock ? 1 : 0
            this.machineProjetcsInterlockResponse = service.interlock_details
            this.devicesDescription = service.devices_and_materials
            this.materialsDescription = service.support_materials
            this.episDescription = service.epi
          })
          .catch((error) => {
            console.log({ error })
          })
          .finally(() => (this.loading = false))
      },
    },
    mounted() {
      this.load()
    },
  }
</script>

<style lang="scss" scoped>
</style>
